export default "__VITE_ASSET__D$vmolCz__"